import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServicesBento } from "@/components/site/ServicesBento";
import { Pillars } from "@/components/site/Pillars";
import { CTABand } from "@/components/site/CTABand";
import { DigitalByDesign } from "@/components/site/DigitalByDesign";
import { KrimzonPromise } from "@/components/site/Promise";
import { WhyKrimzon } from "@/components/site/WhyKrimzon";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <ServicesBento />
      <Pillars />
      <DigitalByDesign />
      <KrimzonPromise />
      <WhyKrimzon />
      <CTABand title="Let's simplify HR. Together." cta="Talk to KRIMZON" />
    </main>
  );
}
